import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Notiflix from 'notiflix';
import { endpoint } from './endpoint';
import SubscriptionPage from './SubscriptionPage';
import './Dashboard2.css';
import { useUser } from './UserContext';

const Dashboard = () => {
    const { user } = useUser();
    const [bags, setBags] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBags = async () => {
            setLoading(true);
            try {
                if (!user) {
                    // Handle case when user is not available
                    return;
                }
                const response = await fetch(`${endpoint}/gymapp/getbags.php?token=${user.token}`);
                if (!response.ok) throw new Error('Network response was not ok');
                const data = await response.json();
                setBags(data.bags || []);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        };

        fetchBags();
    }, [user]);

    if (!user) return <div className="loading">Loading user...</div>;
    if (loading) return <div className="loading">Loading bags...</div>;
    if (error) return <div className="error">Error: {error}</div>;

    return (
       <>
		<br/>
        <SubscriptionPage /><br/><br/><br/>
       </>
    );
};

export default Dashboard;
